import script from "./ArgonTd.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonTd.vue?vue&type=script&setup=true&lang=js"

import "./ArgonTd.vue?vue&type=style&index=0&id=9496a422&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9496a422"]])

export default __exports__